import { createBrowserRouter } from "react-router-dom";
import { ListSitesPage } from "./pages/Sites/ListSites";
import SiteDetailsPage from "./pages/Sites/SiteDetails";
import NewSitePage from "./pages/Sites/NewSite";
import { AuthenticationGuard } from "./components/Auth/AuthorizedClientProvider";
import LoginPage from "./pages/Auth/Login";
import RegisterConfirmPage from "./pages/Auth/RegisterConfirm";
import LayoutComponent from "./layout/layout";
import { OptimizationTaskDetails } from "./pages/Optimizations/OptimizationTaskDetails";
import { Alerting } from "./pages/Alerting/Alerting";
import NotFound from "./pages/NotFound/404";
import AdminPage from "./pages/Auth/AdminPage";
import { IdentitiesPage } from "./pages/Identities/IdentitiesPage";
import { BillingTab } from "./components/Billing/Billing";
import EmulatorListPage from "./pages/Emulator/EmulatorListPage";
import CreateEmulatedSitePage from "./pages/Emulator/CreateEmulatedSitePage";
import EmulatorTransactionPage from "./pages/Emulator/EmulatorTransactionPage";

export const privateRouter = () => {
  return createBrowserRouter([
    // Public routes
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/register/confirm",
      element: <RegisterConfirmPage />,
    },
    {
      path: "/admin",
      element: <AdminPage />,
    },
    {
      path: "/404",
      element: <NotFound />,
    },
    // Protected routes
    {
      element: <AuthenticationGuard />,
      children: [
        {
          element: (
            <LayoutComponent
              action={{ label: "Create new", goTo: "sites/new" }}
            />
          ),
          children: [
            {
              path: "/",
              element: <ListSitesPage />,
            },
            {
              path: "sites",
              element: <ListSitesPage />,
            },
          ],
        },
        {
          element: (
            <LayoutComponent
              action={{ label: "Create new", goTo: "/emulator/create" }}
            />
          ),
          children: [
            {
              path: "emulator",
              element: <EmulatorListPage />,
            },
          ],
        },
        {
          element: <LayoutComponent />,
          children: [
            {
              path: "sites/new",
              element: <NewSitePage />,
            },
            {
              path: "sites/:site_id",
              element: <SiteDetailsPage />,
            },
            {
              path: "optimizations/:id",
              element: <OptimizationTaskDetails />,
            },
            {
              path: "alerting",
              element: <Alerting />,
            },
            {
              path: "identities",
              element: <IdentitiesPage />,
            },
            {
              path: "billing",
              element: <BillingTab />,
            },
            {
              path: "emulator/create",
              element: <CreateEmulatedSitePage />,
            },
            {
              path: "emulator/:site_id",
              element: <EmulatorTransactionPage />,
            },
          ],
        },
      ],
    },
  ]);
};
